export default __webpack_public_path__ + "static/media/viwe_on_map_icon.5fc3987b.svg";